import { hideOnClickOutside } from './functions';

const miniSearchContainer = document.getElementById('mini-search');
const miniSearchButtons = Array.from(document.getElementsByClassName('toggle-search'));


miniSearchButtons.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    hideOnClickOutside(miniSearchContainer, 'open-mini-search');

    document.body.classList.remove('open-mobile-menu');

    // Prevents the menu to be opened again if it already was open.
    // hideOnClickOutside() will close it if it's open
    if (document.body.classList.contains('open-mini-search')) {
      return;
    }

    // This is inside of a timout to prevent it from being closed by hideOnClickOutside() as soon as it's opened
    setTimeout(() => {
      document.body.classList.add('open-mini-search');

      if (document.body.classList.contains('open-mini-search')) {
        const searchField = miniSearchContainer.querySelector('input.search-field');

        if (searchField && 'ontouchstart' in document.documentElement === false) {
          searchField.focus();
        }
      }
    });
  }, 10);
});
